/**
 * casteApi.js
 * -----------
 * API client for Caste Master using createMasterApiClient.
 * Connects directly to FastAPI backend /caste/ endpoints.
 * Exports are processed asynchronously via JobEngine background jobs (useExportJob).
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const casteClient = createMasterApiClient('caste');

export async function listCastes(params = {}) {
  return await casteClient.list(params);
}

export async function getCasteDetail(casteId) {
  return await casteClient.getById(casteId);
}

export async function createCaste(payload) {
  return await casteClient.create(payload);
}

export async function updateCaste(casteId, payload) {
  return await casteClient.update(casteId, payload);
}

export async function archiveCaste(casteId) {
  return await casteClient.archive(casteId);
}

export async function deleteCaste(casteId) {
  return await casteClient.remove(casteId);
}

export async function getCasteOptions() {
  return await casteClient.getDropdownOptions();
}
